<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Trang chủ" :link="[{ text: 'Bảng thông tin chung', href: '../dashboard' }]" />
      </div>
    </div>

    <!-- Thông tin toàn trường -->
    <!-- <CardAcademicLevel /> -->
    <!-- <CardStudent /> -->
    <!-- <CardTeacherAndStaff /> -->
    <!-- <CardSalaryTeacher /> -->

    <!-- Điểm danh - Khen thưởng - Kỷ luật -->
    <v-row class="mx-1 mb-4" v-if="role.type !== 'inspector'">
      <v-col cols="6" v-if="$auth.policies['view-attendance-item']">
        <v-card outlined height="100%">
          <v-card-title class="pr-0">
            <v-icon color="primary">mdi-calendar-account</v-icon>
            <span class="ml-2 text-subtitle-2">Điểm danh hôm nay</span>
            <v-spacer></v-spacer>
            <v-btn @click="goDetail" color="primary" text>Xem chi tiết</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row class="py-6">
              <v-col class="pl-6 text-center" cols="4">
                <span class="col-1">{{ todayAttendanceCount }}</span>
                <br />
                <span class="text-subtitle">Học viên có mặt</span>
              </v-col>
              <v-col class="text-center" cols="2">
                <v-divider class="my-2" vertical></v-divider>
              </v-col>

              <v-col class="text-center" cols="4">
                <span class="col-3th">{{ todayAbsentCount }}</span> <br />
                <span class="text-subtitle">Học viên vắng/quên quẹt thẻ</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" v-if="$auth.policies['view-violation-list']">
        <v-card outlined height="100%">
          <v-card-title class="pr-0">
            <v-icon color="primary">mdi-star</v-icon>
            <span class="ml-2 text-subtitle-2">Ghi chú cần theo dõi tuần</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" text to="/complimented">Xem chi tiết</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row class="py-6">
              <v-col class="text-center" cols="4">
                <span class="col-1">{{ commendationWeekCount || 0 }}</span>
                <br />
                <span class="text-subtitle">Về học tập</span>
              </v-col>
              <v-divider class="my-2" vertical></v-divider>
              <v-col class="text-center" cols="4">
                <span class="col-2">{{ violationWeekCount || 0 }}</span> <br />
                <span class="text-subtitle">Về nội dung khác</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Phản hồi -->
    <v-card class="mx-4 mb-6" outlined v-if="$auth.policies['view-feedback-group'] && role.type !== 'inspector'">
      <v-card-title class="pr-0">
        <v-icon color="primary">mdi-forum</v-icon>
        <span class="ml-2 text-subtitle-2">Phản hồi phụ huynh gần đây</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" text to="/feedback">Xem thêm</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <DashboardFeedbacks />
      </v-card-text>
    </v-card>

    <!-- Thông báo -->
    <v-card outlined class="mx-4" v-if="$auth.policies['view-noti-history']">
      <v-card-title class="pr-0">
        <v-icon color="primary">mdi-bell-ring</v-icon>
        <span class="ml-2 text-subtitle-2">Thông báo trung tâm gần đây</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" text to="/post-history">Xem thêm</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <DashboardNotifications />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters, mapState } from 'vuex'
import DashboardNotifications from '@/modules/dashboard/DashboardNotifications.vue'
import DashboardFeedbacks from '@/modules/dashboard/DashboardFeedbacks.vue'
import CardAcademicLevel from '../../modules/dashboard/CardAcademicLevel.vue'
import CardStudent from '../../modules/dashboard/CardStudent.vue'
import CardTeacherAndStaff from '../../modules/dashboard/CardTeacherAndStaff.vue'
import CardSalaryTeacher from '../../modules/dashboard/CardSalaryTeacher.vue'

export default {
  components: {
    Breadcrumbs,
    DashboardNotifications,
    DashboardFeedbacks,
    CardAcademicLevel,
    CardStudent,
    CardTeacherAndStaff,
    CardSalaryTeacher,
  },
  computed: {
    ...mapState('app', ['currentSchoolYear', 'currentSemester']),
    ...mapState('Dashboard', [
      'classNo',
      'studentNo',
      'teacherNo',
      'todayAttendanceCount',
      'todayAbsentCount',
      'commendationWeekCount',
      'violationWeekCount',
    ]),
    ...mapGetters('auth', ['profile', 'role']),
  },
  async created() {
    await this.fetchDashboardData()
  },
  methods: {
    ...mapActions('Dashboard', ['fetchDashboardData']),

    goDetail() {
      this.$router.push(`/attendances?searchImmediate=true`)
    },
  },
}
</script>

<style scoped>
.col-1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #46be8a;
}
.col-2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #ffab40;
}
.col-3th {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #fd6b6b;
}
</style>
